import React from 'react';
import { Button } from "react-bootstrap";

const EditButton = (props) => (
  <div style={{ textAlign: "right", marginTop: 32, maxHeight: 60 }}>
    <Button {...props}>
      <i className="fas fa-edit"></i>
    </Button>
  </div>
);

export default EditButton